<template>
    <form @submit.prevent="OnSubmit">
        <div v-if="viewData.Errors && viewData.Errors.length > 0">
            <h3>Es sind folgende Fehler aufgetreten</h3>
            <p v-for="msg in viewData.Errors" :key="msg">{{msg}}</p>
            <p>Bitte korrigieren Sie Ihre Eingaben und schicken Sie das Formular noch einmal ab.</p>
            <p><a href="">Noch einmal versuchen</a><br /><br /></p>
        </div>

        <div v-if="viewData.Success && viewData.Success == true">
            <h3>Ihr Passwort wurde erfolgreich ge&auml;ndert.</h3>
            <p><a href="/">Zur Anmeldung</a><br /><br /></p>
        </div>

        <div v-if="!viewData.Success && !(viewData.Errors && viewData.Errors.length > 0)">
            <h3>Schritt 2 (Neues Passwort)</h3>
            <p>Ihr Benutzername: {{model.benutzername}}</p>
            <div class="form input-text-double-1">
                <span class="input">
                    <label>Ihr neues Passwort:</label>
                    <input type="password" v-model="model.passwort" name="passwort" required />
                </span>
                <span class="password-strength-container topmargin"></span>
            </div>
            <div class="form input-text-single-half">
                <span class="input">
                    <label>Neues Passwort wiederholen:</label>
                    <input type="password" v-model="model.passwortWiederholung" name="passwortWiederholung" required />
                </span>
            </div>
            <div class="form input-submit">
                <input type="submit" name="input-submit" id="input-submit" value="Weiter">
            </div>
        </div>
    </form>
</template>
<script lang="ts">
    import ApiService from '@/services/apiService';
import { getFormHashString } from '@/services/formSession';
    import { defineComponent } from 'vue';

    const PasswortVergessenStage2 = defineComponent({
        name: "PasswortVergessenStage2",
        data() {
            return {
                model: {} as { benutzername: string, passwort: string, passwortWiederholung: string, sessionId: string },
                viewData: {} as any,
            }
        },
        props: {
            benutzername: String,
            sessionId: String
        },
        beforeMount() {
            this.model.benutzername = this.benutzername ? this.benutzername : "";
        },
        methods: {
            async OnSubmit() {
                const payload = {
                    Benutzername: this.model.benutzername,
                    Passwort: this.model.passwort,
                    PasswortWiederholung: this.model.passwortWiederholung,
                    SessionId: this.sessionId ? getFormHashString(this.sessionId) : "",
                    Schritt: 1
                };

                try {
                    this.viewData = await ApiService.Instance.PostData("/umbraco/login/ZugangsdatenVergessenForm/ChangePasswort", payload);
                    this.$emit("updateSessionId", this.viewData.sessionId);
                } catch (reason: any) {
                    const responseData = reason?.response?.data;

                    if (responseData?.Errors && Array.isArray(responseData.Errors)) {
                        this.viewData = responseData;
                        return;
                    }

                    const errors = responseData?.errors;
                    if (errors && typeof errors === "object") {
                        const flattenedErrors: string[] = [];

                        for (const key in errors) {
                            if (Object.prototype.hasOwnProperty.call(errors, key)) {
                                const errorMessages = errors[key];
                                if (Array.isArray(errorMessages)) {
                                    flattenedErrors.push(...errorMessages);
                                }
                            }
                        }

                        this.viewData = { Errors: flattenedErrors };
                        return;
                    }

                    this.viewData = { Errors: ["Das Passwort konnte nicht geändert werden."] };
                }
            }
        }

    });
    export default PasswortVergessenStage2;
</script>